import React from "react";
import { Link } from "react-router-dom";
import IconLine from "venuescanner-js/react/components/Objects/Icons/IconLine";
import IconCompletedStep from "venuescanner-js/react/components/Objects/Icons/IconCompletedStep";
import IconUncompletedStep from "venuescanner-js/react/components/Objects/Icons/IconUncompletedStep";
import IconCurrentStep from "venuescanner-js/react/components/Objects/Icons/IconCurrentStep";
import "./Steps.scss";

const Bullet = ({ state }) => {
  return (
    <>
      {state === "completed" && (
        <IconCompletedStep aria-hidden="true" focusable="false" />
      )}
      {state === "uncompleted" && (
        <IconUncompletedStep aria-hidden="true" focusable="false" />
      )}
      {state === "current" && (
        <IconCurrentStep aria-hidden="true" focusable="false" />
      )}
    </>
  );
};

const Line = ({ state }) => {
  return (
    <>
      {state === "completed" && (
        <IconLine aria-hidden="true" focusable="false" color={"#424242"} />
      )}
      {state === "uncompleted" ||
        (state === "current" && (
          <IconLine aria-hidden="true" focusable="false" color={"#E5E5E5"} />
        ))}
    </>
  );
};

const Step = ({ state, title, last }) => {
  return (
    <>
      <Bullet state={state} />
      <span
        className={
          state === "uncompleted" ? "steps__step_gray" : "steps__step_black"
        }
      >
        {title}
      </span>
      {!last && <Line state={state} />}
    </>
  );
};

export const Steps = ({ thread }) => {
  return (
    <div className="steps">
      <Link
        className="steps__step cursor"
        to={`/inbox/${thread._id.toString()}`}
      >
        <Step state="completed" title="Quote" />
      </Link>
      <div className="steps__step">
        <Step state="current" title="Summary" />
      </div>
      <div className="steps__step">
        <Step state="uncompleted" title="Payment" last />
      </div>
    </div>
  );
};
